import './onboarding.scss'
import { NotFound, OnboardingProcessBar, OnboardingSideContent, OnboardingSideContentD2, OnboardingSideContentD3, SupportIcon } from 'src/component'
import { useContext, useEffect, useState } from 'react'
import { useNavigate, Outlet, useLocation } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import access from 'src/utils/localAccess'

export const OnboardingRoutes = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info: {authToken, institutionData}, recoverAppData, logout} = useContext(AppInfoContext)
    const [isAuth, setIsAuth] = useState(!!authToken)
    const [showNotFound, setShowNotFound] = useState<boolean | null>(null)

    const componentInfo: any = {
        class: {
            1: 'onboarding-container',
            2: 'onboarding-container',
            3: 'onboarding-container-d3'
        },
        mainClass: {
            1: 'onboarding-container-main',
            2: 'onboarding-container-main',
            3: 'onboarding-container-main-d3'
        },
        sideContent: {
            1: <OnboardingSideContent />,
            2: <OnboardingSideContentD2 />,
            3: <OnboardingSideContentD3 />
        }
    }

    useEffect(() => {
        initializer()
    }, [])

    async function initializer () {
        await recoverAppData(['theme', 'institutionData', 'onboardingSideInfo', 'termsAndConditions_Privacy', 'hostName'])
        if (!institutionData?.id) await API.getInstitution()
        access.setNavigationAccess(navigate)
        access.setLogoutHandler(logout)
        handleAuth()
    }

    async function handleAuth () {
        let [authToken, onboardingInput, institution, hostName]: any = await Promise.all([
            localStorage.getItem('authToken'), 
            localStorage.getItem('onboardingInput'),
            localStorage.getItem('institutionData'),
            localStorage.getItem('hostName')
        ])
        if (hostName != window.location.hostname) logout()
        setShowNotFound(!JSON.parse(institution)?.id)
        onboardingInput = JSON.parse(onboardingInput!)
        if (!authToken) {
            setIsAuth(!!authToken)
            navigate('/onboarding/type') 
        }
        else if (authToken && onboardingInput?.securityAnswer1) navigate('dashboard')
        else logout()
    }
    
    return (
        <>
            { (!isAuth && !showNotFound && showNotFound != null) ?
                <div 
                    className={(location.pathname.includes('/type') || location.pathname === '/onboarding/' || location.pathname === '/onboarding')  ? (componentInfo.class[institutionData.design] || 'onboarding-container')  : (componentInfo.mainClass[institutionData.design] || 'onboarding-container-main')}
                >
                    {(!location.pathname.includes('/type')  && location.pathname != '/onboarding/' && location.pathname != '/onboarding') && (componentInfo.sideContent[institutionData.design] || <OnboardingSideContent />)}
                    <SupportIcon/>
                    <div className="onboarding-modules">
                        {(!location.pathname.includes('/type') && !location.pathname.includes('/profile-setup-completion') && location.pathname != '/onboarding/' && location.pathname != '/onboarding') && <OnboardingProcessBar />}
                        <Outlet/>
                    </div>
                </div>
                :
                    showNotFound ?
                        <NotFound />
                            : null
            }
        </>
    ) 
}

export default {
    routeProps: {
        path: 'onboarding',
        element: <OnboardingRoutes/>
    },
    name: 'Onboarding'
}